import Constants from "../Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

class SignupActions {

  public start(data: any, fields: any[], callback, error): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_START,
      payload: {
        data: data,
        fields: fields
      },
        onSuccess: () => {
          if (typeof callback === "function") {
            callback();
          }
        },
        onError: () => {
          if (typeof callback === "function") {
            error();
          }
        }
    };
  }

  public request(): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_REQUEST
    };
  }

  public success(): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_SUCCESS,
      payload: {
      }
    };
  }

  public failure(message: string, fields: string[]): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_FAILURE,
      payload: {
        message,
        fields
      }
    };
  }

  public updateCompany(name): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_UPDATE_COMPANY,
      payload: {
        name
      }
    };
  }

  public updateEmail(email): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_UPDATE_EMAIL,
      payload: {
        email
      }
    };
  }

  public updateContact(payload): ActionInterface {
    return {
      type: Constants.PAGE_SIGNUP_UPDATE_CONTACT,
      payload
    };
  }
}

export default new SignupActions();
